module.exports = __webpack_public_path__ + "cba6f3f83cbace2e52f395e60188e210.png";